module.exports = __webpack_public_path__ + "img/common_descriptionlevel_sr.af5839af.svg";